import { CommonModule, NgClass, NgFor } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { DashboardService } from 'src/app/modules/home/dashboard-widgets/services/dashboard.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CustomerData, TopCustomresResponseData } from 'src/app/modules/home/dashboard-widgets/models/dashboard.model';
import { FormatforInitialsPipe } from 'src/app/shared/pipes/format-initial.pipe';
import { MegaNumberPipe} from 'src/app/shared/pipes/meganumber.pipe';
import { ChartUtilities } from 'src/app/shared/utilities/chart-utilities';
import { LoaderComponent } from '../../loader/loader.component';
import { TranslationModule } from 'src/app/modules/i18n';
import { DurationUnits } from 'src/app/modules/home/dashboard-widgets/models/widgets.model';
import { NgbDropdownModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { SharedModule } from 'src/app/_c3-lib/shared/shared.module';
import { CurrencyPipe } from 'src/app/shared/pipes/currency.pipe';
import { C3CommonModule } from 'src/app/shared/c3-common-module/c3-common-module.module';
import { CommonNoRecordComponent } from '../../common-no-record/common-no-record.component';

@Component({
  selector: 'app-top-customers',
  standalone: true,
  imports: [
    NgClass,
    NgFor,CommonNoRecordComponent,
    FormatforInitialsPipe,
    MegaNumberPipe,
    LoaderComponent,
    TranslationModule,
    NgbDropdownModule,
    SharedModule,
    CommonModule,
    NgbTooltip,
    C3CommonModule,
    
  ],
  templateUrl: './top-customers.component.html',
  styleUrl: './top-customers.component.scss'
})
export class TopCustomersComponent {
  selectedTimePeriod: string =  DurationUnits.sixBillingPeriod;
  downloadIconStatus: boolean = false;
  private subscription: Subscription;
  entityName: string | null;
  customerData: CustomerData[];
  startBillingDate:string;
  endBillingDate:string;
  chartUtilities : ChartUtilities;
  isLoading:boolean=false;
  recordId: string|null;
  durationUnits = [
    DurationUnits.all,
    DurationUnits.threeMonths,
    DurationUnits.sixMonths,
    DurationUnits.tweleveMonths,
    DurationUnits.lastBillingPeriod,
    DurationUnits.threeBillingPeriod,
    DurationUnits.sixBillingPeriod,
    DurationUnits.twelveBillingPeriod
  ]
  globalDateFormat: any;
  currencySymbol:any;
  currencyDecimalPlaces:any;
  currencyDecimalSeperator:any;
  currencyThousandSeperator:any;
  currencyCode:any;
  
  constructor(
    private dashboardservice: DashboardService,
    private cdref: ChangeDetectorRef,
    private loaderService: LoaderService,
    private _appService: AppSettingsService,
    private commonService: CommonService
  ) {
  this.chartUtilities = new ChartUtilities()
  }
  ngOnInit(): void {
    this.loaderService.startLoading();
    this.isLoading= true;
    this.globalDateFormat = this._appService.$rootScope.dateFormat;
    this.entityName = this.commonService.entityName;
    this.recordId=this.commonService.recordId;
    this.getCustomersData()
  }
  getCustomersData() {
    let timeDuration;
    if (this.selectedTimePeriod == DurationUnits.all) {
      timeDuration = null;
    }
    else {
      timeDuration = this.selectedTimePeriod;
    }
    this.subscription = this.dashboardservice.getTopCustomers(this.entityName, timeDuration,this.recordId).subscribe((data: Partial<TopCustomresResponseData>) => {
      if (data?.Data) {
        const startDate = data?.Data[0]?.StartDateForLabel;
        const endDate = data.Data[0]?.EndDateForLabel;
        if(!!startDate && endDate){
          this.startBillingDate = startDate;
          this.endBillingDate = endDate;
        }
        this.currencyCode = data?.Data[0]?.CurrencyCode;
        this.currencyDecimalPlaces = data?.Data[0]?.CurrencyDecimalPlaces;
        this.currencyDecimalSeperator = data?.Data[0]?.CurrencyDecimalSeperator;
        this.currencySymbol = data?.Data[0]?.CurrencySymbol;
        this.currencyThousandSeperator = data?.Data[0]?.CurrencyThousandSeperator;
       
        this.customerData = data.Data;
        this.cdref.detectChanges();
      }
      this.loaderService.stopLoading();
      this.isLoading= false;
    });
  }

  selectedDuration(duration: string) {
    this.selectedTimePeriod = duration;
    this.getCustomersData();
  }

  toggleButton() {
    this.downloadIconStatus = !this.downloadIconStatus
  }
  generatePNG(dropdown:any) {
    this.downloadIconStatus = true;
    dropdown.close()
    this.chartUtilities.isloadingstart = true;
    setTimeout(()=>{
    const element = document.getElementById('top-customers-by-revenue-png');
    this.chartUtilities.generatePNG(element, 'Valued-customers')
    this.downloadIconStatus = true;
  },0)
  
  
  }

  generateCSV(dropdown:any) {
    dropdown.close();
    this.downloadIconStatus = true;

    let currenyPipe = new CurrencyPipe();
    let megaNumberPipe = new MegaNumberPipe(currenyPipe);
    let rows = [];
    this.customerData.map(e=>{    
     rows.push({'Customer Name': e.CustomerName, Revenue: megaNumberPipe.transform(e.BilledAmount, this.currencySymbol, this.currencyDecimalPlaces, this.currencyThousandSeperator, this.currencyDecimalSeperator )});
     //rows.push(billedAmount);
    })
    
    this.chartUtilities.generateCSV(rows, 'Valued-customers')
  }

 
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
